import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesSettingValuesDynamicallyForm } from './FormSamplesSettingValuesDynamicallyForm';
import { FormSamplesSettingValuesDynamicallyPageInfo } from './FormSamplesSettingValuesDynamicallyPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
    countryCode: string;
    cityTownCode: string;
}

/////////////////////////////////////////////////////////////////////////////////////////////
// Interfaces below used elsewhere in the project for countries and cities
/////////////////////////////////////////////////////////////////////////////////////////////
export interface CountryDto {
    code: string;
    description: string;
}

export interface CityTownDto {
    code: string;
    description: string;
    countryCode: string;
}

export const FormSamplesSettingValuesDynamicallyPage = () => {

  const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmit = async (values: ExampleDto) => {
    setSubmitting(true);
    setSubmittedValues(values);

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PageContainer
      heading='Form Samples - Set Values Dynamically'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesSettingValuesDynamicallyPageInfo />}
    >
      <PageDefaultSegment width={400}>
        <FormSamplesSettingValuesDynamicallyForm
          submitting={submitting}
          onSubmit={handleSubmit}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={400} submittedValues={submittedValues} />
    </PageContainer>
  )
}
